import { DragDropContext, DropResult } from "@hello-pangea/dnd";
import { ActivityKanbanColumn } from "./ActivityKanbanColumn";
import { FAZER_AMIZADE_ETAPAS, type FazerAmizadeEtapa, type ActivityDetail } from "@/types/activity";

interface ActivityKanbanBoardProps {
  activities: ActivityDetail[];
  onMoveCard: (activityId: number, novaEtapa: FazerAmizadeEtapa) => void;
  onCardClick: (activity: ActivityDetail) => void;
}

export function ActivityKanbanBoard({
  activities,
  onMoveCard,
  onCardClick,
}: ActivityKanbanBoardProps) {
  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const activityId = parseInt(result.draggableId);
    const novaEtapa = result.destination.droppableId as FazerAmizadeEtapa;

    if (result.source.droppableId !== result.destination.droppableId) {
      onMoveCard(activityId, novaEtapa);
    }
  };

  // Agrupar atividades por etapa
  const activitiesByEtapa = FAZER_AMIZADE_ETAPAS.reduce((acc, etapa) => {
    acc[etapa.id] = activities.filter((a) => a.etapa_kanban === etapa.id);
    return acc;
  }, {} as Record<FazerAmizadeEtapa, ActivityDetail[]>);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent">
        {FAZER_AMIZADE_ETAPAS.map((etapa) => (
          <ActivityKanbanColumn
            key={etapa.id}
            etapa={etapa}
            activities={activitiesByEtapa[etapa.id] || []}
            onCardClick={onCardClick}
          />
        ))}
      </div>
    </DragDropContext>
  );
}
